var $preload = $('.preload');
var $loading = $('#js-loading');
var $progressBar = $('#js-progress');
var $container = $('#js-container');
$container.addClass('is-loading');

var imgSrcs = [];

$preload.find('img').each(function(){
    imgSrcs.push($(this).attr('src'));
});
var loader = new $.ImgLoader({
    srcs : imgSrcs, //画像などのパスを配列に格納
    pipesize: 2, //同時にロードできる数の上限
    delay: 500,  //次のロードまでの遅延をミリ秒で指定
    timeout: 500,  //タイムアウトまでの時間をミリ秒で指定
    useXHR2: false //XMLHttpRequestVersion2を利用するかどうか
});

loader.on('progress', function(progress) {
    var prog = progress.loadedRatio; //進捗率を取得
    TweenMax.to($progressBar, 0.5, {
        width: progress.loadedRatio*100 + '%' //進捗率を取得
    });
});

loader.on('itemload', function($img) {
});

loader.on('allload', function($img) {
    $container.removeClass('is-loading');
    TweenMax.to($loading, 0.5, {
        autoAlpha: 0,
        onComplete: function() {
            TweenMax.set($loading, {display: 'none'});
        },
        delay: 1
    });
});

loader.load();  //ローディングを実行



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/js/app.js
 **/